/** 개발요청 한 건을 여는 화면 주소. 개발요청 화면의 공유 링크 규약(`kind`/`item`)을 따른다. */
export class DevRequestLink {
  static href(id: number): string {
    return `/project-board/dev-requests?item=${id}&kind=dev-request`;
  }

  /**
   * PRD `## Dev request` 절의 `- 개발요청: #59` 줄을 그 요청을 여는 링크로 바꾼다.
   * 하네스가 쓰는 줄 모양 그대로만 잡는다 — 본문 아무 데나 있는 `#59`는 이슈 번호일 수도 있어 건드리지 않는다.
   */
  static linkify(markdown: string): string {
    return markdown.replace(
      /^(\s*[-*]\s*개발요청:\s*)#(\d+)\b/gm,
      (_, prefix: string, id: string) => `${prefix}[#${id}](${DevRequestLink.href(Number(id))})`,
    );
  }
}
